import * as React from "react";
import { WaitingOrderTransactions } from "../waiting-order-transactions";

// OrderTransactionType.Buy = 1
export const BuysWaitingForAcceptReceipt = () => (
    <WaitingOrderTransactions
        orderType={1}
        pageTitle="خرید های در انتظار تایید"
        cardTitle="خرید های در انتظار"
        className="pmx-buys-waiting-for-accept-receipt"
        exportFileName="خرید های در انتظار"
    />
);
